import { Component, Input } from '@angular/core';
import { NewsItem } from '../../../interfaces/news-item';

@Component({
  selector: 'app-news-item',
  templateUrl: './news-item.component.html',
  styleUrls: ['./news-item.component.scss']
})
export class NewsItemComponent {
  @Input({ required: true }) data!: NewsItem;
  @Input({ required: true }) openArticleBtnText!: string;
  @Input() isLoading: boolean = false;
}
